'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var confirmed = require('./confirmed-45bc4a9e.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 0 32px;\n  color: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 0 32px;\n  color: ",
    ";\n"])), function (_a) {
    var theme = _a.theme, isUserGeneratedSurvey = _a.isUserGeneratedSurvey;
    return (isUserGeneratedSurvey
        ? theme.colors.greys.adminGreyDark : theme.colors.universal.black);
});
var FeedbackSentText = styled__default.p(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  margin: 82px 0 0;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: 26px;\n  line-height: 30px;\n  text-align: center;\n"], ["\n  margin: 82px 0 0;\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: 26px;\n  line-height: 30px;\n  text-align: center;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.darkGrey7;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var isUserGeneratedSurvey = _a.isUserGeneratedSurvey;
    return (isUserGeneratedSurvey ? 500 : 700);
});
var Text = styled__default.p(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  font-family: ", ";\n  margin: 16px 0 0;\n  font-size: 17px;\n  line-height: 20px;\n  text-align: center;\n"], ["\n  font-family: ", ";\n  margin: 16px 0 0;\n  font-size: 17px;\n  line-height: 20px;\n  text-align: center;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var HqoQuestionFeedbackSent = function (_a) {
    var feedbackData = _a.feedbackData, questionText = _a.questionText, isUserGeneratedSurvey = _a.isUserGeneratedSurvey;
    return (React__default.createElement(Container, { isUserGeneratedSurvey: isUserGeneratedSurvey },
        React__default.createElement(confirmed.Confirmed, { size: "none", "data-testid": "feedback-sent-icon" }),
        React__default.createElement(FeedbackSentText, { isUserGeneratedSurvey: isUserGeneratedSurvey }, questionText),
        React__default.createElement(Text, null, feedbackData.lineText1)));
};
var templateObject_1, templateObject_2, templateObject_3;

exports.HqoQuestionFeedbackSent = HqoQuestionFeedbackSent;
